import LinkToDocusaurus from '../LinkToDocusaurus'
import { apiAccess } from '../../docs-routes'

const LinkToAPIAccessDoc = () =>
  <LinkToDocusaurus path={apiAccess}>
    Learn more about API Access
  </LinkToDocusaurus>

export default LinkToAPIAccessDoc
